import { render } from "./ResidentBanner.vue?vue&type=template&id=1f823254&scoped=true"
import script from "./ResidentBanner.vue?vue&type=script&lang=js"
export * from "./ResidentBanner.vue?vue&type=script&lang=js"

import "./ResidentBanner.vue?vue&type=style&index=0&id=1f823254&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f823254"]])

export default __exports__